<template>
  <!-- 杂志详情页 -->
  <div>
    <div class="main">
      <div class="breadcrumb">
        <span
          class="crumb"
          @click="
            $router.push({ path: '/' });
            resetSetItem('isActive', 0);
          "
          >首页</span
        >
        <span>></span>
        <span class="crumb" @click="$router.push({ path: '/read' })">阅读</span>
        <span>></span>
        <span>{{ this.magaLog.summary }}</span>
      </div>
      <div class="main-content">
        <div class="content-l">
          <div class="l-box">
            <div v-for="(item, i) in magalogList" :key="i" class="list">
              <div class="img">
                <img :src="item.column_icon" alt />
              </div>
              <div class="cont">
                <div
                  class="magacolunm"
                  :class="{
                    describeA: more_divA == i,
                    describeB: more_divB == i,
                    describeC: more_divC == i,
                    describeD: more_divD == i,
                    describeE: more_divE == i
                  }"
                  @click="more(i)"
                >
                  {{ item.column_summary }}
                </div>
                <div class="arctileList" v-if="item.isShow == true">
                  <!-- <p @click="more2(i)" class="ppp">查看更多</p> -->
                  <p v-if="item.articles">共{{ item.articles.length }}篇文章</p>

                  <div
                    v-for="(items, index) in item.articles"
                    :key="index"
                    @click="articlesDetail(items)"
                  >
                    <span>·</span>
                    {{ items.title }}
                  </div>
                </div>
                <p @click="more(i)" v-if="item.isShow == false">查看更多</p>
                <p v-else style="margin: 20px" @click="retract(i)">
                  收起
                  <img src="@/assets/img/icon_retract.png" alt />
                </p>
              </div>
              <div class="blank"></div>
            </div>
          </div>
        </div>
        <div class="content-r">
          <div class="right-box">
            <div class="publish">
              <!-- v-for="(items,index) in magaLog"
                    :key="index"
                    @click="rightDetail(items)" -->
              <p class="title">本期杂志封面</p>
              <div class="img">
                <img :src="magimg" alt />
              </div>
              <div class="cont">
                <p>{{ this.magaLog.summary }}</p>
                <p class="time">
                  <span>{{ message_time | timefilters }}</span>
                  <span>NO.{{ this.magaLog.maga_all_number }}</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getMagazinesList } from "@/api/read";
import { getMagazines } from "@/api/read";
import { getTdkList} from "@/api/tdk";

export default {
  data() {
    return {
      id: "",
      title: "",
      more_divA: 0,
      more_divB: 1,
      more_divC: 2,
      more_divD: 3,
      more_divE: 4,
      magimg: require("@/assets/img/cont_mask.png"),
      magalogList: [
        {
          img: require("@/assets/img/history.png"),
          cont:
            "杂志主打栏目“有故事”,每期聚焦一个重磅话题讨论，由多篇不同视角、不同篇幅的文章组成",
          arctileList: [
            {
              name: "全球化之困"
            },
            {
              name: "中国商业模式如何重启"
            },
            {
              name: "全球化之困"
            },
            {
              name: "中国商业模式如何重启"
            },
            {
              name: "购物中心想吸引更多的孩子可能是一   件值得反思的事"
            }
          ],
          arctileNum: 5,
          isShow: false
        }
      ],
      message_cover: "",
      message_time: "",
      message_seria: "",
      isShow: false,

      // 右侧杂志数据
      magaLog: {
        id: "",
        summary: "",
        cover_url: "",
        maga_all_number: "",
        isShow: false
      }
    };
  },
  methods: {
    more(index) {
      if (index == 0) {
        var obj = document.getElementsByClassName("describeA")[0];
        obj.style.display = "block";
      } else if (index == 1) {
        var obj = document.getElementsByClassName("describeB")[0];
        obj.style.display = "block";
      } else if (index == 2) {
        var obj = document.getElementsByClassName("describeC")[0];
        obj.style.display = "block";
      } else if (index == 3) {
        var obj = document.getElementsByClassName("describeD")[0];
        obj.style.display = "block";
      } else if (index == 4) {
        var obj = document.getElementsByClassName("describeE")[0];
        obj.style.display = "block";
      }
      this.magalogList[index].isShow = !this.magalogList[index].isShow;
    },
    retract(index) {
      if (index == 0) {
        var obj = document.getElementsByClassName("describeA")[0];
        obj.style.display = "-webkit-box";
      } else if (index == 1) {
        var obj = document.getElementsByClassName("describeB")[0];
        obj.style.display = "-webkit-box";
      } else if (index == 2) {
        var obj = document.getElementsByClassName("describeC")[0];
        obj.style.display = "-webkit-box";
      } else if (index == 3) {
        var obj = document.getElementsByClassName("describeD")[0];
        obj.style.display = "-webkit-box";
      } else if (index == 4) {
        var obj = document.getElementsByClassName("describeE")[0];
        obj.style.display = "-webkit-box";
      }
      this.magalogList[index].isShow = !this.magalogList[index].isShow;
    },
    getList(id) {
      getMagazinesList(id).then(res => {
        var magalogList = res.data.data;
        magalogList.forEach((value, index) => {
          value["isShow"] = false;
        });
        this.magalogList = magalogList;
      });
    },

    getMag(id) {
      getMagazines(id).then(res => {
        var magaLog = res.data.data;
        // magaLog.forEach((value, index) => {
        //   value["isShow"] = false;
        // });
        this.magaLog.id = magaLog.id;
        this.magaLog.summary = magaLog.summary;
        this.magaLog.cover_url = magaLog.cover_url;
        this.magaLog.maga_all_number = magaLog.maga_all_number;
        this.magimg = this.magaLog.cover_url;
        this.$ba([
          ["ptype", "list"],
          ["acategory", "magazine"],
          ["acname", "杂志"],
          ["acategory2", "magazine" + this.magaLog.id],
          ["ac2name", this.magaLog.summary]
        ]);
      });
    },

    // 文章详情
    articlesDetail(item) {
      this.$router.push({
        name: "article_detail",
        params: {
          id: item.id,
          titleType: this.title,
          isRead: true,
          readType: "",
          readId: this.id,
          readTypes: this.type,
          readCover: this.message_cover,
          readTime: this.message_time,
          readSeria: this.message_seria
        }
      });
    },
    // 右侧杂志详情
    rightDetail(item) {
      this.$router.push({
        name: "right_detail",
        params: {
          id: item.id,
          summary: this.summary,
          imgUrl: this.cover_url,
          number: this.maga_all_number
        }
      });
    }
  },
  created() {
    getTdkList({column:0}).then(res => {
      console.log(res)
      const head = document.getElementsByTagName('head')
      const meta = document.createElement('meta')
      document.title= res.data.data[0].title;
      document.querySelector('meta[name="keywords"]').setAttribute('content',res.data.data[0].keyword)
      document.querySelector('meta[name="description"]').setAttribute('content', res.data.data[0].describe)
      head[0].appendChild(meta)
    })

    this.id = this.$route.params.id;
    this.type = this.$route.params.type;
    this.title = this.$route.params.title;
    this.message_cover = this.$route.params.cover;
    this.message_time = this.$route.params.time;
    this.message_seria = this.$route.params.seria;
    this.resetParams(this, [
      "type",
      "id",
      "title",
      "message_cover",
      "message_time",
      "message_seria"
    ]);

    this.getList(this.id);
    this.getMag(this.id);
  },
  // 省略号展开为文字
  more2(index) {
    let button = document.getElementsByTagName("button");
    let p = document.getElementsByTagName("p");

    for (let i = 0; i < button.length; i++) {
      p[i].onclick = function() {
        if (this.innerHTML == "查看更多") {
          p[i].classList.remove("describe");
          p[i].classList.add("all-txt");
          this.innerHTML = "收起";
        } else {
          p[i].classList.remove("all-txt");
          p[i].classList.add("describe");
          this.innerHTML = "查看更多";
        }
      };
    }
  }
};
</script>
<style lang="scss" scoped>
.breadcrumb {
  color: #999999;
  font-size: 14px;
  line-height: 20px;
  padding-top: 20px;
  padding-bottom: 16px;
  .crumb {
    cursor: pointer;
  }
  span:last-child {
    color: #0091ff;
  }
}
.l-box {
  background: #ffffff;
  padding: 30px;
  margin-bottom: 60px;
  .list {
    display: flex;
    flex-direction: row;
    .img {
      width: 25%;
      img {
        width: 100%;
        object-fit: cover;
        vertical-align: bottom;
      }
    }
    .cont {
      background: #d8eeff;
      line-height: 34px;
      font-size: 18px;
      padding: 30px;
      width: 42%;
      padding-bottom: 0;
      .magacolunm {
        cursor: pointer;
        // text-overflow: -o-ellipsis-lastline;
        text-overflow: ellipsis;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        overflow: hidden;
        margin-top: 14px;
        position: relative;
        text-align: justify;
      }
      .describeA {
        display: -webkit-box;
      }
      .describeB {
        display: -webkit-box;
      }
      .describeC {
        display: -webkit-box;
      }
      .describeD {
        display: -webkit-box;
      }
      .describeE {
        display: -webkit-box;
      }
      .all-txt {
        // overflow : hidden;
        // text-overflow: ellipsis;
        // display: -webkit-box;
        // -webkit-line-clamp: 100;
        // -webkit-box-orient: vertical;
        clear: both;
        min-height: 1em;
        white-space: pre-wrap;
      }
      p {
        color: #0091ff;
        text-align: right;
        cursor: pointer;
      }
      .arctileList {
        p {
          font-size: 16px;
          color: #999999;
          text-align: left;
          margin-top: 5px;
          cursor: context-menu;
          // float: left;
        }
        div {
          font-size: 20px;
          border-bottom: 1px solid #b0cade;
          padding: 10px 0;
          cursor: pointer;
          display: flex;
          span {
            margin-right: 6px;
          }
        }
        div:hover {
          color: #0091ff;
        }
      }
    }
  }
  .list:nth-child(2) {
    .img {
      margin-left: 25%;
    }
    .cont {
      background: #ffffff;
      border: 1px solid #eeeeee;
    }
  }
  .list:nth-child(3) {
    flex-direction: row-reverse;
    .img {
      margin-right: 25%;
    }
  }
  .list:nth-child(4) {
    flex-direction: row-reverse;
    .cont {
      background: #ffffff;
    }
  }
  .list:nth-child(5) {
    flex-direction: row-reverse;
    .img {
      margin-right: 25%;
    }
  }
}
.list:nth-child(2n) {
  .cont {
    background: #ffffff;
    border: 1px solid #eeeeee;
  }
}
.right-box {
  background: #ffffff;
  margin-bottom: 30px;
  .publish {
    text-align: center;
    padding: 30px;
    font-size: 16px;
    .title {
      font-weight: bold;
    }
    .img {
      margin: 30px 0 20px 0;
      max-width: 200px;
      height: 253px;
      display: inline-block;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .audio {
      margin: 30px 0 20px 0;
      max-width: 200px;
      height: 200px;
      display: inline-block;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .cont {
      line-height: 22px;
      .time {
        font-size: 14px;
        color: #999999;
        display: flex;
        justify-content: center;
        align-items: center;
        span {
          margin-right: 10px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/read/magalog.vue